/* tslint:disable */
/* eslint-disable */
/**
 * Doppio API
 * Microservice backend for ...
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum DealTypeEnum {
    ConsumerLoan = 'CONSUMER_LOAN',
    InvestmentLoan = 'INVESTMENT_LOAN',
    SaleAndLeaseback = 'SALE_AND_LEASEBACK',
    Sale = 'SALE',
    Borrowing = 'BORROWING',
    Lease = 'LEASE',
    Leasing = 'LEASING',
    OtherDeal = 'OTHER_DEAL'
}

export function DealTypeEnumFromJSON(json: any): DealTypeEnum {
    return DealTypeEnumFromJSONTyped(json, false);
}

export function DealTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): DealTypeEnum {
    return json as DealTypeEnum;
}

export function DealTypeEnumToJSON(value?: DealTypeEnum | null): any {
    return value as any;
}

